import avatarModule from '../avatarModule';

function avatarItemCard(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarItemCard
  };
}

avatarModule.directive('avatarItemCard', avatarItemCard);

export default avatarItemCard;
